import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';

export const transformProductCardPropsForTracking = (tracking: Record<string, any>): EcommerceCartItem => {
  const { name, id, brand, category } = tracking.gtm;
  const { saveAmount, displayPriceInc } = tracking.pricing;
  const list = tracking.ecommerceExtraProps?.list;
  const flags = tracking.productTags;
  const reviewCount = tracking.reviewCount;
  const reviewScore = tracking.reviewScore;

  const categories = category?.split('/');

  const item: EcommerceCartItem = {
    discount: saveAmount,
    item_bestseller_flag: flags?.join(', ') || 'none',
    item_brand: brand,
    item_category: categories?.[0] || '(unavailable)',
    item_category2: categories?.[1] || '(unavailable)',
    item_category3: categories?.[2] || '(unavailable)',
    item_category4: categories?.[3] || '(unavailable)',
    item_id: id,
    item_list_name: list || '(unavailable)',
    item_name: name,
    item_review_count: reviewCount || '(unavailable)',
    item_review_score: reviewScore || '(unavailable)',
    item_variant: id,
    price: displayPriceInc,
  };

  return item;
};
